import { ContractBuilderContent } from './contract-builder-content';

export function ContractBuilderPage() {
  return <ContractBuilderContent />;
}
